
import { computed, defineComponent, ref } from 'vue'
import { HSwipe } from '@nio-fe/horo-h5'
import { imgOptimize } from './utils/tool'

import type { WallMediaListItem } from './types/index'

export type ImagePreviewProps = {
  show: (content: WallMediaListItem[], index: number) => void
  hide: () => void
}

export default defineComponent({
  name: 'ImagePreview',
  components: {
    'h-swipe': HSwipe,
  },
  setup(props, { expose, emit }) {
    const mockSwap = (process.config as { [key: string]: any })['mockSwap']
    const pictureWallList = ref<WallMediaListItem[]>([])
    const imagePreviewRef = ref(false)
    const current = ref(0)
    const IconUrl =
      mockSwap === 'alps'
        ? 'https://cdn-fx.nio.com/fx/pe-h5pages-fe-alps/__cdn__/icon_close_s.svg'
        : 'https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/icon_close_s.svg'
    const mobile = computed(() => document.documentElement.clientWidth < 500)
    expose({
      show: (content: WallMediaListItem[], index: number) => {
        pictureWallList.value = content
        current.value = index
        imagePreviewRef.value = true
      },
      hide: () => {
        imagePreviewRef.value = false
        emit('hasHide', true)
      },
    })
    const hide = () => {
      imagePreviewRef.value = false
      emit('hasHide', true)
    }

    return {
      mobile,
      imagePreviewRef,
      hide,
      pictureWallList,
      current,
      IconUrl,
      imgOptimize,
    }
  },
})
